import { regStepIds } from '../../../../../utils/eventConstants';

// The gate used to run before the password, so arriving here meant it was already behind the
// player. Now that the password comes first, the gate has to be picked up here or a
// password-protected event would skip it altogether.
export function getStepAfterPassword({ showUpgrade, isCampEvent, isMultiRegistrationAllowed }) {
    if (showUpgrade) {
        return regStepIds.UPGRADE;
    }
    if (isCampEvent && isMultiRegistrationAllowed) {
        return regStepIds.CAMP_USER_SELECTION;
    }
    return regStepIds.DIVISIONS;
}
